import { useEffect } from "react";
import { useLocation } from "react-router";

/** Fire a GA4 event when gtag is present; a no-op otherwise (dev, tests, no VITE_GA_ID). */
export function track(event, params = {}) {
  if (typeof window !== "undefined" && typeof window.gtag === "function") {
    window.gtag("event", event, params);
  }
}

/**
 * GA4's own page_view only fires on a full page load, and this site navigates client-side,
 * so every page after the first would go uncounted. Analytics.jsx turns the automatic one
 * off (`send_page_view: false`) and this sends one per location instead — including the
 * first, which is why nothing double-counts.
 */
export function usePageViews() {
  const location = useLocation();
  useEffect(() => {
    if (typeof window === "undefined" || typeof window.gtag !== "function") return;
    window.gtag("event", "page_view", {
      page_path: `${location.pathname}${location.search}`,
      page_location: window.location.href,
      page_title: document.title,
    });
  }, [location.pathname, location.search]);
}
